// extracted by mini-css-extract-plugin
module.exports = {"scrollToTopButton":"style_scrollToTopButton__3UY_u","shadow":"style_shadow__2r2ql"};